import { z } from "zod";

import { DocumentSchema } from "./schemas";
import { MAX_FILES_PER_UPLOAD_REQUEST } from "./uploads";

export const GenerateUploadUrlResponseSchema = z.object({
  documentId: z.uuid().meta({ visibleTo: "*" }),
  uploadUrl: z.url().meta({ visibleTo: "*" }),
  s3Key: z.string().meta({ visibleTo: "*" }),
  contentType: z
    .string()
    .min(1)
    .describe("The Content-Type the client must send when PUTting to uploadUrl.")
    .meta({ visibleTo: "*" }),
  expiresIn: z.literal(300).meta({ visibleTo: "*" }),
});
export type GenerateUploadUrlResponse = z.infer<typeof GenerateUploadUrlResponseSchema>;

export const GenerateUploadUrlsResponseSchema = z.object({
  items: z
    .array(GenerateUploadUrlResponseSchema)
    .min(1)
    .max(MAX_FILES_PER_UPLOAD_REQUEST)
    .meta({ visibleTo: "*" }),
});
export type GenerateUploadUrlsResponse = z.infer<typeof GenerateUploadUrlsResponseSchema>;

export const ListDocumentsResponseSchema = z.object({
  items: z.array(DocumentSchema).meta({ visibleTo: "*" }),
});
export type ListDocumentsResponse = z.infer<typeof ListDocumentsResponseSchema>;

/**
 * Lenient document shape for API responses where role-specific field sets may
 * omit required record fields.
 */
const DocumentApiResponseSchema = DocumentSchema.partial().extend({
  id: z.uuid().meta({ visibleTo: "*" }),
});

export type DocumentApiResponse = z.infer<typeof DocumentApiResponseSchema>;

export const ListDocumentApiResponsesSchema = z.object({
  items: z.array(DocumentApiResponseSchema).meta({ visibleTo: "*" }),
});
export type ListDocumentApiResponses = z.infer<typeof ListDocumentApiResponsesSchema>;

export const DocumentViewUrlResponseSchema = z.object({
  viewUrl: z.url().meta({ visibleTo: "*" }),
});

export const CaseDocumentsArchiveResponseSchema = z.object({
  downloadUrl: z
    .url()
    .describe("Short-lived signed URL serving the archive as a file download")
    .meta({ visibleTo: "*" }),
});
